<div class="container mat-elevation-z8">
    <table mat-table [dataSource]="requestsDataSource" matSort>

        <!-- Player Column -->
        <ng-container matColumnDef="User">
          <div class="mat-header-cell">
            <mat-header-cell *matHeaderCellDef> Player </mat-header-cell>
          </div>
          <mat-cell *matCellDef="let element"> {{element.User}} </mat-cell>
        </ng-container>

        <!-- Request Column -->
        <ng-container matColumnDef="Request">
          <mat-header-cell *matHeaderCellDef> Request </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Request}} </mat-cell>
        </ng-container>

        <!-- Hole Column -->
        <ng-container matColumnDef="Location">
          <mat-header-cell *matHeaderCellDef> Location </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Location}} </mat-cell>
        </ng-container>

        <!-- Time Column -->
        <ng-container matColumnDef="Time">
          <mat-header-cell *matHeaderCellDef> Time </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Time}} </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Status}} </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index;">
            <button mat-icon-button color="accent" (click)="acknowledgeRequest(i)">
              <mat-icon>check_circle_outline</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="completeRequest(i)">
              <mat-icon>check_circle_outline</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="removeRequest(i)">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <!-- Footer that displays if there's no data returned -->
        <ng-container matColumnDef="noData">
          <mat-footer-cell *matFooterCellDef colspan="6">
              No Current Requests
          </mat-footer-cell>
        </ng-container>
      
        <mat-header-row *matHeaderRowDef="requestsDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: requestsDisplayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(requestsDataSource!=null && requestsDataSource.data.length==0)}"></mat-footer-row>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
